import PictogramLibrary from './PictogramLibrary';

export default PictogramLibrary;
